import { Chip } from '@mui/material'

// Status-Badge für den m2-finance-Rechnungsstatus (docs/35 K3):
// Der Versand läuft nach dem Cutover asynchron über m2-finance — der
// Rückfluss (finance_status) trägt den sichtbaren Zustand der Rechnung.
export type FinanceStatus =
  | 'in_delivery'
  | 'push_failed'
  | 'delivered'
  | 'delivery_failed'
  | 'paid'
  | 'canceled'
  | 'rejected'
  | string

const STATUS_CONFIG: Record<
  string,
  { label: string; color: 'default' | 'info' | 'success' | 'error' | 'warning' }
> = {
  in_delivery: { label: 'In Zustellung', color: 'info' },
  push_failed: { label: 'Übertragung fehlgeschlagen', color: 'error' },
  delivered: { label: 'Zugestellt', color: 'success' },
  delivery_failed: { label: 'Zustellung fehlgeschlagen', color: 'error' },
  paid: { label: 'Bezahlt', color: 'success' },
  canceled: { label: 'Storniert', color: 'default' },
  rejected: { label: 'Abgelehnt', color: 'warning' }
}

type Props = {
  status?: string | null
  size?: 'small' | 'medium'
}

export function FinanceStatusBadge({ status, size = 'small' }: Props) {
  if (!status) return null
  const config = STATUS_CONFIG[status] || { label: status, color: 'default' as const }
  return <Chip label={config.label} color={config.color} size={size} variant="outlined" />
}

export default FinanceStatusBadge
